import { writable } from 'svelte/store';

export const count = writable( sessionStorage.getItem('tierSelection') || 0 );
